import React from 'react';
import { SignUp } from '@clerk/clerk-react';
import SeoHead from "../components/SeoHead";
import { useI18n } from "../i18n/i18n";

export default function AuthSignup() {
  const { t, localizePath } = useI18n();
  return (
    <div className="pageContainer" style={{ display: 'flex', justifyContent: 'center', paddingTop: 40 }}>
      <SeoHead
        title={t("auth.signUpTitle")}
        description={t("auth.signUpDescription")}
        canonicalPath={localizePath("/sign-up")}
        noIndex={true}
      />
      <h1 style={{ position: "absolute", left: "-9999px" }}>{t("auth.signUpHeading")}</h1>
      <SignUp
        routing="path"
        path={localizePath("/sign-up")}
        signInUrl={localizePath("/sign-in")}
        afterSignUpUrl={localizePath("/")}
      />
    </div>
  );
}
